import moment from "moment";

export const waitingTime = (startDate) => {
	return moment(startDate).from(moment());
	//moment(moment().diff(startDate)).toTimeString().split(' ')[0];
};

export const getFormattedTimeFromMinutes = (minutes) => {
	if (!minutes) return "/";
	let min = parseInt(minutes);
	if (Math.floor(min / 60) > 0) return String.prototype.concat(Math.floor(min / 60), " h ", min % 60, " min");
	else return String.prototype.concat(min % 60, " min");
};

export const getFormattedTimeFromSeconds = (sec) => {
	if (!sec) return "/";
	let seconds = parseInt(sec);
	if (Math.floor(seconds / 3600) > 0)
		return String.prototype.concat(Math.floor(seconds / 3600), " h ", Math.floor(seconds / 60) % 60, " min ", seconds % 60, " sec");
	else if (Math.floor(seconds / 60) > 0) return String.prototype.concat(Math.floor(seconds / 60) % 60, " min ", seconds % 60, " sec");
	else return String.prototype.concat(seconds % 60, " sec");
};

export const dateDiff = (oldDate, newDate) => {
	var diff = {}; // Initialisation du retour
	if (newDate === undefined || newDate === null) newDate = moment(new Date());
	var tmp = moment(newDate) - moment(oldDate);
	tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
	diff.sec = tmp % 60; // Extraction du nombre de secondes
	tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
	diff.min = tmp % 60; // Extraction du nombre de minutes
	tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
	diff.hour = tmp % 24; // Extraction du nombre d'heures
	tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
	diff.day = tmp;
	return diff;
};

export const getWaitingTime = (start, end) => {
	let result = "";
	if (start) {
		let diff = {};
		if (end) diff = dateDiff(start, end);
		else diff = dateDiff(start);
		if (diff.day > 0) result = `${diff.day} j `;
		if (diff.hour > 0) result += `${diff.hour} h `;
		if (diff.min > 0) result += `${diff.min} min`;
		if (diff.min === 0 && diff.hour === 0 && diff.day === 0) result += `maintenant`;
	}

	return result;
};

export const getTimeBetweenInSec = (d1, d2) => {
	if (d2 === undefined || d2 === null) d2 = moment(new Date());
	return Math.floor((moment(d1) - moment(d2)) / 1000);
};

export const formatTime = (time) => {
	return moment(time).format("DD/MM/YYYY");
};

export const formatDateAndTime = (time) => {
	return moment(time).format("DD/MM/YYYY HH:mm:ss");
};
